import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const INACTIVITY_TIME = 30 * 60 * 1000; // 30 minutos

const SessionManager = () => {
  const navigate = useNavigate();

  useEffect(() => {

    let inactivityTimer;

    const logoutByInactivity = () => {

      sessionStorage.removeItem('token');
      sessionStorage.removeItem('name');
      sessionStorage.removeItem('role');
      sessionStorage.removeItem('email');

      sessionStorage.setItem('sessionExpired', 'true');

      navigate('/login', { replace: true });
    };

    const resetTimer = () => {

      clearTimeout(inactivityTimer);

      // Solo controlar la sesión si realmente está logueado
      const token = sessionStorage.getItem('token');

      if (!token) {
        return;
      }

      inactivityTimer = setTimeout(
        logoutByInactivity,
        INACTIVITY_TIME
      );
    };

    const events = [
      'mousemove',
      'mousedown',
      'keydown',
      'scroll',
      'touchstart',
      'click'
    ];

    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer();

    return () => {

      clearTimeout(inactivityTimer);

      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });

    };

  }, [navigate]);

  return null;
};

export default SessionManager;